import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';
import { captureConsoleIntegration } from '@sentry/integrations';
import { getSentryBaseOptions, shouldEnableSentry } from './sentry-config.js';
export class SentryFrontendErrorLogger {
    constructor() {
        this.isEnabled = false;
        // Keep the constructor side-effect free when Sentry is disabled in this env.
        if (!shouldEnableSentry()) {
            console.log('Sentry is disabled for this environment.');
            return;
        }
        // Initialize Capacitor Sentry once for browser/mobile webview capture.
        // The app uses LinkedErrorLogging.log(...) later for explicit test/manual events.
        Sentry.init({
            ...getSentryBaseOptions(),
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
                captureConsoleIntegration({
                    levels: ['error'],
                }),
            ],
            tracesSampleRate: 0.1,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        }, SentryReact.init);
        this.isEnabled = true;
    }
    async log(error) {
        if (!this.isEnabled) {
            return;
        }
        // Capture the error explicitly and flush so manual test actions show up quickly.
        Sentry.captureException(error);
        await Sentry.flush(2000);
    }
}
//# sourceMappingURL=SentryFrontendErrorLogger.js.map